module.exports = __webpack_public_path__ + "static/2_Council-d51aa0ade88a6589ea340131a152cef1.svg";